import { useEffect } from 'react';
import { Capacitor } from '@capacitor/core';
import { ScreenOrientation } from '@capacitor/screen-orientation';

/**
 * Hook para bloquear rotación de pantalla solo en mobile (< 640px)
 * En tablet y desktop permite rotación libre
 */
export function useScreenOrientation() {
  useEffect(() => {
    // Solo en plataformas nativas
    if (!Capacitor.isNativePlatform()) {
      return;
    }

    const handleResize = async () => {
      const width = window.innerWidth;
      
      try {
        if (width < 640) {
          // Mobile: bloquear en portrait
          await ScreenOrientation.lock({ orientation: 'portrait' });
        } else {
          // Tablet/Desktop: permitir rotación
          await ScreenOrientation.unlock();
        }
      } catch (error) {
        console.warn('Error managing screen orientation:', error);
      }
    };

    // Ejecutar al montar
    handleResize();

    // Escuchar cambios de tamaño (si el usuario conecta/desconecta teclado, etc)
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
      
      // Limpiar al desmontar
      if (Capacitor.isNativePlatform()) {
        ScreenOrientation.unlock().catch(() => {});
      }
    };
  }, []);
}
